import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useContext, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { shapes, swatchBorderWidth, swatchDiameters, swatchPadding, } from './constants';
import { SwatchPickerContext } from './SwatchPickerContext';
const strikethroughBorderWidth = 3;
const offset = swatchBorderWidth + swatchPadding;
const SwatchPickerStrikethrough = () => {
    const { shape, size, } = useContext(SwatchPickerContext);
    const containerSize = useMemo(() => (swatchDiameters[size] - (swatchPadding * 2) - (swatchBorderWidth * 2)), [
        size,
    ]);
    const containerStyles = useMemo(() => (css `
        height: 100%;
        position: absolute;
        width: 100%;

        ${shape === shapes.CIRCLE && css `
          border-radius: 100%;
          clip-path: circle(50% at 50% 50%);
          height: ${styleUtils.rem(containerSize)};
          left: ${styleUtils.rem(offset)};
          top: ${styleUtils.rem(offset)};
          width: ${styleUtils.rem(containerSize)};
        `}

        ${shape === shapes.SQUARE && css `
          clip-path: inset(
            ${styleUtils.rem(offset)}
            ${styleUtils.rem(offset)}
            ${styleUtils.rem(offset)}
            ${styleUtils.rem(offset)}
          );
          left: 0;
          top: 0;
        `}
      `), [
        containerSize,
        shape,
    ]);
    const strikethroughStyles = useMemo(() => (css `
        border-left-color: ${theme.colors.gray400};
        border-left-style: solid;
        border-left-width: ${styleUtils.rem(strikethroughBorderWidth)};
        height: 100%;
        margin: auto;
        transform: skew(45deg);
        width: 0;
      `), []);
    return (_jsx("div", Object.assign({ css: containerStyles }, { children: _jsx("div", { css: strikethroughStyles }) })));
};
const MemoizedSwatchPickerStrikethrough = memo(SwatchPickerStrikethrough);
export { MemoizedSwatchPickerStrikethrough as SwatchPickerStrikethrough };
